import styled from '@emotion/styled';
import { Box } from '@gemini/fe-ds-core';
import type { BoxProps } from '@gemini/fe-ds-core';
import { MobileBreakpoint } from '@utils/consts/breakpoints.consts';

export const AppointmentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  padding-top: 0.5rem;
  padding-bottom: 1rem;

  @media screen and (max-width: ${MobileBreakpoint}px) {
    padding-top: 0;
    padding-bottom: 0.5rem;
  }
`;

export const AppointmentsContainer = styled.div`
  width: 100%;
  padding-right: 1rem;
  padding-left: 1rem;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;

  @media screen and (max-width: ${MobileBreakpoint}px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;

export const AppointmentGridItem = styled.div`
  width: 100%;
  display: block;
`;

export const AppointmentOption = styled.button<{
  selected?: boolean;
  selectedColor: string;
  color: string;
  minHeight?: boolean;
}>(
  {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '7.5rem',
    maxHeight: '12rem',
    height: '100%',
    gap: '1rem',
    padding: '1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    width: '100%',
  },
  ({ selected, selectedColor, color, minHeight }) => ({
    minHeight: minHeight ? '7.5rem' : 'unset',
    border: selected ? `1px solid ${selectedColor}` : `1px solid ${color}`,
    '&:focus-visible': {
      outline: `2px solid ${selectedColor}`,
      outlineOffset: '0.25rem',
      borderRadius: '4px',
    },
  }),
);

export const AppointmentTypeWrapper = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.25rem;
  width: 100%;
`;

export const AppTypeInfoModalContentBox: React.ComponentType<BoxProps> = styled(
  Box,
)<BoxProps>`
  padding: 1rem 1rem 0rem;
  font-weight: 400;
  font-size: 0.875rem;
  ul {
    margin-left: 0.5rem;
    padding-inline-start: 1rem;
  }
`;
